import { useOutletContext, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { format, parseISO } from 'date-fns';
import DetailsTable from 'src/components/DetailsTable';
import EntityStatusCard from 'src/components/EntityStatusCard';
import usePackagedAppGeneral from '../../../../../../queries/packagedAppDetails/useGetPackagedAppGeneral';
import { Loader } from '../../../../../../components';

// Status and notes are edited in the card above rather than listed here, so nothing on this table
// is interactive.
const fieldsToRender = [
  { key: 'displayName', label: 'Display Name' },
  { key: 'packageFamilyName', label: 'Package Family Name' },
  { key: 'description', label: 'Description' },
  { key: 'signatureKind', label: 'Signature Kind' },
  { key: 'affectedDevicesCount', label: 'Impacted Devices' },
  { key: 'publisher', label: 'Publisher' },
  { key: 'publisherDisplayName', label: 'Publisher Display Name' },
  { key: 'isFramework', label: 'Is Framework' },
  { key: 'statusUpdatedOn', label: 'Status Updated On' },
];

const renderFieldValue = (key, value) => {
  if (key === 'isFramework') {
    return value ? 'Yes' : 'No';
  }

  if (key === 'statusUpdatedOn') {
    return value ? format(parseISO(value), 'yyyy-MM-dd') : 'no data';
  }

  if (typeof value === 'number') {
    return value.toLocaleString();
  }

  return value || 'no data';
};

const PackagedAppDeviceGeneralSection = () => {
  const { packagedAppId } = useParams();
  const { onEditStatus, editDisabled } = useOutletContext() ?? {};
  const { isLoading, data: packagedAppGeneral } = usePackagedAppGeneral({ packagedAppId });

  if (isLoading) {
    return (
      <Box mt={'80px'}>
        <Loader />
      </Box>
    );
  }

  return (
    <Stack gap={2}>
      <EntityStatusCard
        name={packagedAppGeneral?.displayName}
        status={packagedAppGeneral?.status || 'Unknown'}
        note={packagedAppGeneral?.notes}
        onEdit={onEditStatus}
        disabledEdit={editDisabled}
      />

      <DetailsTable
        rows={fieldsToRender.map(({ key, label }) => ({
          key,
          label,
          value: renderFieldValue(key, packagedAppGeneral[key]),
        }))}
      />
    </Stack>
  );
};

export default PackagedAppDeviceGeneralSection;
